import { Component, ElementRef, input, viewChild } from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';
import { NgClass, NgStyle } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

export type TTooltipChartsItem = {
  label?: string;
  value?: number | string;
  color?: string;
  iconLeft?: string;
  iconRight?: string;
  /**
   * When `true`, the item's colored marker is rendered as a 2x2 checker
   * with opposite quadrants using `color` and the other two using
   * `var(--border-inverted)`. Used to flag
   * reference/comparison series (e.g. the previous year's dashed line on
   * the YoY chart).
   */
  dashed?: boolean;
}
@Component({
  selector: 'lib-tooltip-charts',
  imports: [NgStyle, NgClass, TranslateModule],
  templateUrl: './tooltip-charts.component.html',
  styleUrl: './tooltip-charts.component.css',
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('200ms', style({ opacity: 1 }))
      ]),
      transition(':leave', [
        animate('200ms', style({ opacity: 0 }))
      ])
    ])
  ]
})
export class TooltipChartsComponent {

  /**
   * Reference to the tooltip element
   */
  public readonly tooltipRef = viewChild<ElementRef<HTMLElement>>('tooltipRef');
  /**
   * Sidebar color
   */
  public readonly color = input<string>();
  /**
   * Tooltip title
   */
  public readonly tooltipTitle = input<string>();
  /**
   * Tooltip content
   */
  public readonly content = input<TTooltipChartsItem[]>([]);
  /**
   * A flag to show or hide the tooltip
   */
  public readonly show = input<boolean>(false);
  /**
   * Tooltip position
   */
  public readonly position = input<{ top: number, left: number }>({ top: 0, left: 0 });

  /**
   * When `true`, the tooltip uses `position: fixed` (viewport-relative) so
   * it can escape parents with `overflow: hidden`. Caller must compute
   * `position` in viewport coordinates (e.g. via `getBoundingClientRect`).
   * Defaults to `false` (absolute, parent-relative).
   */
  public readonly fixed = input<boolean>(false);

  /**
   * When `true`, the tooltip uses dark color mode.
   * @default false
   */
  public readonly isDarkColorMode = input<boolean>(false);

}